module.exports = __webpack_public_path__ + "assets/img/service2.687a9798.png";